import React from 'react';
import {
  TextStyle,
  Text,
  useWindowDimensions,
  View,
  ViewStyle,
  Image,
  ImageStyle,
} from 'react-native';
import {Button} from 'ui-kits';
import {corner_radius, spacing} from 'theme/Units';
import {usePlatformStyles} from 'hooks';
import {mergeDeepRight} from 'ramda';

type propType = Readonly<{
  openModal: () => void;
}>;

export function Features(props: propType): JSX.Element {
  const {openModal} = props;
  const webStyles = usePlatformStyles('web');

  type boxStylesType = {
    blueBoxStyle: ViewStyle;
    yellowBoxStyles: ViewStyle;
    greenBoxStyles: ViewStyle;
    purpleBoxStyles: ViewStyle;
    pinkBoxStyles: ViewStyle;
    slateBoxStyle: ViewStyle;
  };

  const boxBaseStyles: boxStylesType = {
    blueBoxStyle: {
      backgroundColor: '#70D4EA',
      ...webStyles({gridArea: '1 / 1 / 3 / 2'}),
    },
    yellowBoxStyles: {
      backgroundColor: '#FEDF6B',
      ...webStyles({gridArea: '1 / 2 / 2 / 4'}),
    },
    greenBoxStyles: {
      backgroundColor: '#D6E79F',
      ...webStyles({gridColumn: '1/ 3'}),
    },
    purpleBoxStyles: {
      backgroundColor: '#C6B2EF',
    },
    pinkBoxStyles: {
      backgroundColor: '#FFB5B9',
    },
    slateBoxStyle: {
      backgroundColor: '#A4C2FF',
    },
  };

  /**
   * responsiveness logic
   */
  const SCREEN_WDITH = useWindowDimensions().width;
  let overrideStyles = structuredClone(baseStyles);
  let overrideBoxStyles = structuredClone(boxBaseStyles);

  if (SCREEN_WDITH < 1280) {
    overrideStyles.heading.fontSize = 32;
    overrideStyles.paragraph.fontSize = 22;

    // blue image
    overrideStyles.blueImage.width = 170;
    overrideStyles.blueImage.height = 170;

    // green image 200,120
    overrideStyles.greenImage.height = 110;
    overrideStyles.greenImage.width = 184;
    overrideStyles.greenImage.right = 20;
    overrideStyles.greenImage.bottom = 20;

    overrideStyles.orangeImage.width = 180;
    overrideStyles.orangeImage.height = 126;
  }

  if (SCREEN_WDITH < 1024) {
    overrideStyles.heading.fontSize = 30;
    overrideStyles.paragraph.fontSize = 20;
    overrideStyles.grid.gap = spacing['3'];

    overrideStyles.grid.gridTemplateColumns = '1fr .5fr 1fr';
    overrideStyles.grid.gridTemplateRows = 'repeat(4, auto)';
    overrideBoxStyles.yellowBoxStyles.gridArea = '1 / 1 / 2 / -1';
    overrideBoxStyles.blueBoxStyle.gridArea = '3 / 1 / 4 / -1';
    overrideBoxStyles.pinkBoxStyles.gridArea = '2 / 2 / 3 / -1';

    overrideBoxStyles.yellowBoxStyles.minHeight = 150;
    overrideBoxStyles.blueBoxStyle.minHeight = 150;

    overrideStyles.block.padding = spacing['6'];
    overrideStyles.block.gap = spacing['6'];

    // blue image
    overrideStyles.blueImage.width = 100;
    overrideStyles.blueImage.height = 100;
    overrideStyles.blueImage.right = 10;
    overrideStyles.blueImage.left = null;
    overrideStyles.blueImage.top = '50%';
    overrideStyles.blueImage.transform = 'translate(0px, -50%)';

    // green image
    overrideStyles.greenImage.height = 83.85;
    overrideStyles.greenImage.width = 140;
    overrideStyles.greenImage.right = 10;
    overrideStyles.greenImage.bottom = 10;

    // orange image
    overrideStyles.orangeImage.transform = 'scale(1, -1)';
    overrideStyles.orangeImage.width = 160;
    overrideStyles.orangeImage.height = 112;
    overrideStyles.orangeImage.top = null;
    overrideStyles.orangeImage.bottom = 0;
  }

  if (SCREEN_WDITH < 860) {
    overrideStyles.grid.width = '100%';

    overrideStyles.paragraph.maxWidth = 500;

    overrideStyles.blueImage.width = 80;
    overrideStyles.blueImage.height = 80;
    overrideStyles.blueImage.right = 20;

    overrideStyles.heading.fontSize = 28;
    overrideStyles.paragraph.fontSize = 18;
  }

  if (SCREEN_WDITH < 768) {
    overrideStyles.heading.fontSize = 26;
    overrideStyles.paragraph.fontSize = 16;
    overrideStyles.block.padding = spacing['5'];
    overrideStyles.block.gap = spacing['5'];

    overrideStyles.paragraph.maxWidth = 400;
  }
  if (SCREEN_WDITH < 720) {
    overrideStyles.heading.fontSize = 24;
    overrideStyles.paragraph.fontSize = 14;
    overrideStyles.block.padding = spacing['4'];
    overrideStyles.block.gap = spacing['4'];
    overrideStyles.grid.gap = spacing['2'];

    overrideStyles.greenImage.height = 71.87;
    overrideStyles.greenImage.width = 120;

    overrideStyles.block.borderRadius = corner_radius.rounded;

    overrideStyles.orangeImage.width = 140;
    overrideStyles.orangeImage.height = 98;
  }
  if (SCREEN_WDITH < 640) {
    overrideStyles.heading.fontSize = 18;
    overrideStyles.block.padding = spacing['3'];
    overrideStyles.block.gap = spacing['3'];
    overrideStyles.block.paddingHorizontal = spacing['2'];

    overrideStyles.paragraph.maxWidth = 350;
    overrideStyles.blueImage.width = 60;
    overrideStyles.blueImage.height = 60;
    overrideStyles.blueImage.top = null;
    overrideStyles.blueImage.right = 20;
    overrideStyles.blueImage.bottom = 20;
    overrideStyles.blueImage.transform = 'translate(0px, 0px)';

    overrideStyles.greenImage.height = 71.87;
    overrideStyles.greenImage.width = 100;

    overrideStyles.orangeImage.width = 120;
    overrideStyles.orangeImage.height = 84;
  }
  if (SCREEN_WDITH < 480) {
    overrideStyles.heading.fontSize = 16;
    overrideStyles.paragraph.fontSize = 12;
    overrideStyles.block.padding = spacing['2'];
    overrideStyles.block.gap = spacing['2'];
    overrideStyles.grid.gap = spacing['1'];
    overrideStyles.greenImage.width = 80;

    overrideStyles.orangeImage.width = 100;
    overrideStyles.orangeImage.height = 70;
    overrideStyles.block.borderRadius = corner_radius['rounded-sm'];
  }
  if (SCREEN_WDITH < 360) {
    overrideStyles.heading.fontSize = 14;
    overrideStyles.paragraph.fontSize = 10;
    overrideStyles.block.padding = spacing['1'];
    overrideStyles.block.gap = spacing['1'];
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyles) as any;
  const boxStyles: boxStylesType = mergeDeepRight(
    boxBaseStyles,
    overrideBoxStyles,
  ) as any;



  return (
    <View style={styles.container}>
      <View style={styles.grid}>
        {/* blue box - the epicenter of productivity */}
        <View style={[styles.block, boxStyles.blueBoxStyle]}>
          <Text style={styles.heading}>The Epicenter of Productivity</Text>
          <Text style={styles.paragraph}>
            Say goodbye to chaos and hello to clarity. With everything at your
            fingertips, productivity reaches unparalleled heights.
          </Text>
          <Image
            style={[styles.baseImage, styles.blueImage]}
            source={require('assets/images/features/blue.png')}
          />
        </View>

        {/* yello box - The Catalyst for Limitless Innovation */}
        <View style={[styles.block, boxStyles.yellowBoxStyles]}>
          <Text style={styles.heading}>
            The Catalyst for Limitless Innovation
          </Text>
          <Text style={styles.paragraph}>
            Unleash creativity with a portal that removes barriers and
            amplifies possibilities. 1IDP accelerates your journey from idea to
            implementation, transforming bold visions into extraordinary
            realities.
          </Text>
          <Image
            style={[styles.baseImage, styles.orangeImage]}
            source={require('assets/images/features/orange.png')}
          />
        </View>

        {/* purple box - Security Without Compromise */}
        <View style={[styles.block, boxStyles.purpleBoxStyles]}>
          <Text style={styles.heading}>Security Without Compromise</Text>
          <Text style={styles.paragraph}>
            Innovation thrives on trust. 1IDP ensures your tools, data, and
            workflows are as secure as they are accessible.
          </Text>
        </View>

        {/* pink box - Effortless Mastery, Every Step of the Way */}
        <View style={[styles.block, boxStyles.pinkBoxStyles]}>
          <Text style={styles.heading}>
            Effortless Mastery, Every Step of the Way
          </Text>
          <Text style={styles.paragraph}>
            Empower developers to become masters of their craft.  1IDP lets you
            focus on what truly matters—innovation and impact.
          </Text>
        </View>

        {/* green box - A Symphony of Collaboration */}
        <View style={[styles.block, boxStyles.greenBoxStyles]}>
          <Text style={styles.heading}>A Symphony of Collaboration</Text>
          <Text style={styles.paragraph}>
            Where individual brilliance meets collective genius. Together, build
            solutions that inspire.
          </Text>
          <Image
            style={[styles.baseImage, styles.greenImage]}
            source={require('assets/images/features/green.png')}
          />
        </View>

        {/* slate box - A Living Ecosystem of Knowledge */}
        <View style={[styles.block, boxStyles.slateBoxStyle]}>
          <Text style={styles.heading}>A Living Ecosystem of Knowledge</Text>
          <Text style={styles.paragraph}>
            Gone are the days of static documentation. 1IDP is a dynamic
            knowledge hub, evolving to meet the ever-changing needs of your
            organization.
          </Text>
        </View>
      </View>
      <Button variant="primary" text="Experience the Advantage" />
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  grid: ViewStyle;
  block: ViewStyle;
  heading: TextStyle;
  paragraph: TextStyle;
  greenImage: ImageStyle;
  blueImage: ImageStyle;
  orangeImage: ImageStyle;
  baseImage: ImageStyle;
};

const baseStyles: styleType = {
  container: {
    marginBottom: spacing['12'],
    alignItems: 'center',
    gap: spacing['12'],
    paddingHorizontal: spacing['4'],
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(3, 350px)',
    gap: spacing['4'],
    width: '100%',
    maxWidth: 1396,
  },

  heading: {
    fontSize: 36,
    fontWeight: '700',
  },
  paragraph: {
    fontSize: 24,
    fontWeight: '500',
    maxWidth: 700,
  },

  block: {
    flex: 1,
    borderRadius: corner_radius['rounded-md'],
    backgroundColor: '#D6E79F',
    paddingHorizontal: spacing['8'],
    paddingVertical: spacing['3'],
    gap: spacing['8'],
    overflow: 'hidden',
  },
  baseImage: {
    width: 100,
    height: 100,
    position: 'absolute',
    resizeMode: 'contain',
    zIndex: -10,
  },
  blueImage: {
    width: 200,
    height: 200,
    bottom: 50,
    left: '50%',
    transform: 'translate(-50%, 0px)',
  },
  greenImage: {
    width: 200,
    height: 120,
    bottom: 50,
    right: 50,
  },
  orangeImage: {
    top: 10,
    right: 0,
    width: 200,
    height: 140,
  },
};
